import axiosInstance from './instance';

const rsaApi = {
  // 캠퍼스 별 고유 RSA 암호화 키 반환
  getRsaKey(brandCode: string) {
    return axiosInstance.get(`/auth/rsa/brand?brandCode=${brandCode}`);
  },
};

export default rsaApi;
